<template>
	<div v-if="reportData && project">

		<div v-if="reportData.status === 'NEW' || reportData.status === 'REQUESTED_CHANGES'" class="d-none print-only">
			<h1>Wydruk próbny !</h1></div>

		<v-layout justify-end mr-3 class="no-print">
			<v-btn @click="exportCosts" v-if="project.financialDocumentsIncluded">Eksportuj tabelę kosztów</v-btn>
			<v-btn @click="print">Wydrukuj</v-btn>
		</v-layout>

		<final-report-header
			:project="project"
			:report-data="reportData"
			:show-approved-header="reportData.status === 'APPROVED'"/>

		<v-divider class="ma-5"/>

		<div class="mt-3 mb-3 read-only-offer-basic-section-generic">
			<h2 style="margin-left: 20px; page-break-after: avoid">{{configuration.form.sections[0].name}} </h2>
			<vue-form-generator
				name="generator"
				ref="vfg"
				:model="reportDataModel"
				:options="formGenerator.formOptions"
				:schema="formGenerator.currentSchema"
				v-if="viewData.showGenerator">
			</vue-form-generator>
		</div>

		<v-divider class="ma-5"/>

		<div v-if="project.financialDocumentsIncluded">
			<div style="page-break-inside: avoid;">
				<h2 style="margin-left: 20px" class="mb-1">Sprawozdanie z wykonania wydatków</h2>
				<final-report-financial-table
					ref="reportFinancialTable"
					:project-data="reportData.fromProject"
					:invoices-data="reportData.fromDocuments.invoices"
					:readonly="readonly"
					class="costs-summary-table final-report"
				/>
			</div>

			<final-report-invoices
				ref="finalReportInvoices"
				:invoices="reportData.fromDocuments.invoices"
				:show-invoices-warning="showInvoicesWarning"
				:donation="invoicesWarningDonation"
				:project-start-date="project.projectStartDate"
				:project-end-date="project.projectEndDate"
				:terms="terms"
			/>

			<v-divider class="ma-5"/>
		</div>

		<final-report-volunteers-print-view
			:volunteers="reportData.fromProject.volunteers"
		/>

		<v-divider class="ma-5"/>

		<final-report-signature/>

		<div v-if="reportData.status === 'NEW' || reportData.status === 'REQUESTED_CHANGES'" class="d-none print-only">
			<h1>Wydruk próbny !</h1></div>
	</div>
</template>

<script>
	import FinalReportFinancialTable from "./FinalReportFinancialTable";
	import FinalReportHeader from "./FinalReportHeader";
	import {genericFormUtil} from "@/utils/genericFormUtil";
	import {Api} from "@/api";
	import {FinalReport} from "@/api/generated/FinalReport";
	import FinalReportSignature from "./FinalReportSignature";
	import FinalReportInvoices from "./FinalReportInvoices";
	import {Files} from "@/utils/Files";
	import {Dates} from "@/utils/Dates";
	import {FundingTypes} from "./Utils/FinalReportFundingTypes";
	import {Project} from "@/api/generated/Project";
	import FinalReportVolunteersPrintView from "./FinalReportVolunteersPrintView";

	export default {
		name: "FinalReportPrintView",
		components: {
			FinalReportVolunteersPrintView,
			FinalReportInvoices,
			FinalReportSignature,
			FinalReportHeader,
			FinalReportFinancialTable,
		},

		mixins: [Dates],

		watch: {

			reportData: {
				handler () {
					this.$nextTick(() => {
						if (this.$refs.reportFinancialTable) {
							this.showInvoicesWarning = parseFloat(this.$refs.reportFinancialTable.sumOfCostsFromTypesFromDocument([FundingTypes.DOTATION]).toFixed(2)) >
                  parseFloat(this.$refs.reportFinancialTable.sumOfCostsFromTypesFromProject([FundingTypes.DOTATION]).toFixed(2));
							this.invoicesWarningDonation = this.$refs.reportFinancialTable.sumOfCostsFromTypesFromProject([FundingTypes.DOTATION]);
						}
					});
				}
			}
		},

		data () {
			return {
				project: null,

        terms: {},

				reportData: null,

				reportDataModel: undefined,

				configuration: {
					form: "",
				},

				viewData: {
					showGenerator: false,
					sendReportDialog: false,
				},

				formGenerator: {
					currentSchema: {},
					currentModel: {},
					formOptions: {
						validateAfterLoad: false,
						validateAfterChanged: true,
						validateAsync: true,
					},
					currentConditionalHashes: [],
				},

				projectId: this.$route.params.projectId,
				showInvoicesWarning: false,
				invoicesWarningDonation: null,

				readonly: true,
				asd: true
			};
		},

		methods: {
			async loadData () {
				await Api.syncGet(this, "/final-report/configuration?projectId=".concat(this.projectId), successResponse => {
					this.configuration.form = genericFormUtil.decodeSchema(successResponse.schema);

          if (!this.configuration.form) {
            this.$messagesBus.$emit("error", "Niezdefiniowany formularz generyczny");
            return;
          }

					this.formGenerator.currentSchema = genericFormUtil.getSectionSchemaFromSchema(this.configuration.form, 0);
				});

				FinalReport.getData(this, this.projectId, success => {
					this.reportData = success;
					if (this.reportData.filledForm === null) {
						this.reportDataModel = genericFormUtil.buildModelFromSchema(this.configuration.form).sections[0].fields;
					} else {
						this.reportDataModel = genericFormUtil.decodeSchema(this.reportData.filledForm);
					}
					this.applyGenericForm(this.configuration.form);
					this.viewData.showGenerator = true;
				});

				Project.getPublicBasicData(this, this.$route.params.projectId, projectBasicData => {
          this.project = projectBasicData;
					FinalReport.getSendAndApprovalDates(this, this.$route.params.projectId, dates => {
						this.sendDate = dates.sendDate;
						this.approvalDate = dates.approvalDate;
					});
				});

        Project.getTerms(this, this.$route.params.projectId, successResponse => {
          this.terms = successResponse;
        }, errorResponse => {
          this.$messagesBus.$emit("error", "Nie udało się załadować terminów", errorResponse);
        });
			},

			applyGenericForm (form) {
        if (!form) {
          this.$messagesBus.$emit("error", "Niezdefiniowany formularz generyczny");
          return;
        }

				let schema = genericFormUtil.getSectionSchemaFromSchema(form, 0, this.readonly);
				if (genericFormUtil.sectionSchemaContainsConditionalField(schema)) {
					let schemaValues = this.reportDataModel;
					this.formGenerator.currentSchema = genericFormUtil.filterSchemaByConditionalFieldsValue(schema, schemaValues);
					let indexes = genericFormUtil.calculateIndexes(schema);
					this.formGenerator.currentConditionalHashes = genericFormUtil.getConditionalValueHashes(schema, indexes);
				} else {
					this.formGenerator.currentSchema = schema;
				}
			},

			async print () {
				await Files.methods.downloadFileAsBlob(
					this,
					Files.methods.getReportPrintUrl(this.projectId, "final"),
					"sprawozdanie_końcowe.pdf"
				);
			},

			exportCosts () {
				let reportFinancialTableComponent = this.$refs.reportFinancialTable;
				let finalReportInvoicesComponent = this.$refs.finalReportInvoices;
				let financialTable = reportFinancialTableComponent.generateExport();
				let reportInvoices = finalReportInvoicesComponent.generateExport();
				let requestBody = {...financialTable, ...reportInvoices};

				FinalReport.postCostsExport(this, this.projectId, requestBody, successResponse => {
						let filename = "egranty_export_" + Dates.methods.getFilenameTimestamp() + "_raport.xlsx";
						this.$messagesBus.$emit("success", "Eksport danych wykonano do pliku " + filename, successResponse);
						Files.methods.downloadBlobResponse(successResponse, filename);
					},
					errorResponse => {
						this.$messagesBus.$emit("error", "Eksport nieudany", errorResponse);
					},
					{
						responseType: "blob"
					});
			},
		},

		mounted () {
			this.loadData();
		},
	};
</script>

<style>

</style>
